//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BBreadcrumb } from "bootstrap-vue";
import { Icon } from "@iconify/vue2";
import { getCourseDurationText } from "~/utils/course";

export default {
  name: "CoursePausedState",
  components: { BBreadcrumb, Icon },
  props: {
    course: {
      type: Object,
      required: true,
    },
    suggestedCourses: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    courseDuration() {
      return this.course.duration
        ? getCourseDurationText(this.course.duration)
        : "";
    },
    breadcrumbItems() {
      const cat = this.course.category;
      const firstCategory = Array.isArray(cat) ? cat[0] : cat;
      return [
        { text: "Cursos", to: this.localePath("/cursos") },
        {
          text: firstCategory || "Curso",
          to: {
            path: this.localePath(
              firstCategory ? `/cursos?category=${firstCategory}` : "/cursos"
            ),
            hash: "#cursos",
          },
        },
        { text: this.course.name, active: true },
      ];
    },
  },
};
